import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from "redux";
import ActionTypes from "../../../constants/ActionTypes";
import MiddlewareEntities from "../../../constants/MiddlewareEntities";
import { apiRequest } from "../api/actions";
import { createErrorNotification, getNotification } from "../notification/actions";
import { setPageShellAction, normalizedPageShellAction } from './actions';
import { setLoader } from "../ui/actions";
import ApiUrls from "../../../constants/ApiUrls";
import { IPageShellState } from "./types";
import LoginDataFactory from "../../../factories/LoginDataFactory";
import { getSessionData } from "../sessionData/actions";
import Config from "../../../config/config";

export const getPageShellMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);
  switch (action.type) {
  case ActionTypes.PAGE_SHELL.FETCH_SESSION:
    next(apiRequest(
      null,
      'GET', ApiUrls.PAGES_HEADER,
      null,
      null,
      MiddlewareEntities.PAGE_SHELL,
      {}),
    );
    break;
  case ActionTypes.PAGE_SHELL.FETCH_HEADER:
    next(apiRequest(
      null,
      'GET', `${Config.websiteRoot}${Config.websitePrefix}${store.getState().language.language}${ApiUrls.PAGE_SHELL}`,
      null,
      null,
      MiddlewareEntities.SITE_HEADER,
      {}),
    );
    break;
  case `${MiddlewareEntities.PAGE_SHELL} ${ActionTypes.API_SUCCESS}` :
    next(getSessionData(action.payload.data.session, ApiUrls.PAGES_HEADER));
    next(getNotification(action.payload.data.session.flashMessages,  MiddlewareEntities.PAGE_SHELL));
    break;
  case `${MiddlewareEntities.SITE_HEADER} ${ActionTypes.API_SUCCESS}` :
    next(normalizedPageShellAction(action.payload));
    break;
  case `${MiddlewareEntities.PAGE_SHELL} ${ActionTypes.API_ERROR}` :
    next(setLoader(false, MiddlewareEntities.PAGE_SHELL));
    next(createErrorNotification(action.payload.data,  MiddlewareEntities.PAGE_SHELL));
    break;
  case `${MiddlewareEntities.SITE_HEADER} ${ActionTypes.API_ERROR}` :
    next(setLoader(false, MiddlewareEntities.PAGE_SHELL));
    break;
  }
};

export const normalizePageShellMiddleware: Middleware =
    (store: MiddlewareAPI) =>
      (next: Dispatch) =>
        (action: AnyAction) => {
          next(action);

          switch (action.type) {
          case ActionTypes.PAGE_SHELL.PROCESS:
            const language = store.getState().language.language;
            const section = store.getState().section.section;
            const numberOfOrderItems = store.getState().session.numberOfOrderItems;
            const user = store.getState().session.user;
            const labels = require(`../../../translations/${language}`);
            const normalizedData: IPageShellState = {
              data: {
                header: {
                  genericLinks: [],
                  item: {}
                },
                footer: {},
                login: null
              }
            };

            normalizedData.data.header.genericLinks = action.payload.data.pageData.header.genericLinks;
            normalizedData.data.header.item = action.payload.data.pageData.header[section];
            normalizedData.data.footer = action.payload.data.pageData.footer;
            normalizedData.data.login = LoginDataFactory.create(section, user, labels, numberOfOrderItems);
            next(setPageShellAction(normalizedData));
          }
        };

export const pageShellMiddleware = [getPageShellMiddleware, normalizePageShellMiddleware];
